import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const Dot = styled.span`
  width: ${props => props.theme.spacing.sp8};
  height: ${props => props.theme.spacing.sp8};
  border-radius: 50%;
  background-color: ${props => props.color};
  flex-shrink: 0;
`

export const SentimentRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp12};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.spacing.sp8};
`

export const Bar = styled.div`
  display: flex;
  flex: 1;
  gap: ${props => props.theme.spacing.sp2};
  height: ${props => props.theme.spacing.sp8};
  background-color: transparent;
`

export const BarSegment = styled.div`
  height: 100%;
  width: ${props => props.width}%;
  background-color: ${props => props.color};
  border-radius: 2px;
`
